module.exports = __webpack_public_path__ + "static/media/book_animation_end.0197ef44.png";